import "pluggin_variable_weight/main";
import "plugin_add_online_shipping/main";
import { saveUrlInSessionStorage, recoverUrlInSessionStorage, verifyUrlInSessionStorage, verifyMiniCartQuantity } from "./redirectUrl";
const processInclude = require('base/util');

$(document).ready(() => {
    processInclude(require('./storeLocator/selectStoreModal'));
    
    const currentPath = window.location.pathname;
    // Evitar carga Checkout y Order-Confirm (no hay barra de navegación)
    if (!currentPath.includes('Checkout') && !currentPath.includes('Order-Confirm')) {
        processInclude(require('./components/miniCart'));
        processInclude(require('./components/smartHeader'));
        processInclude(require('./components/loginInteractions'));
    }

    var footer = $('#footercontent').first();
    var mainContent = $('#maincontent').first();
    var screenHeight = $(window).height();

    if (footer.length > 0 && mainContent.length > 0) {
        var footerBottomPosition = footer.position().top + footer.outerHeight( true );
        var spaceBelowFooter = screenHeight - footerBottomPosition;
        if (spaceBelowFooter > 0) {
            mainContent.css('min-height', (mainContent.height() + spaceBelowFooter));
        }
    }

    $(document).on('click', '.store-selector-buttons', function() {
        saveUrlInSessionStorage();
        
        var redirectUrl = $(this).data('url');
        window.location.href = redirectUrl;
    })

    $(document).on('click', '.store-selector-buttons-confirm', function() {
        var returnToUrl = recoverUrlInSessionStorage();
        var isCalledFromCheckout = verifyUrlInSessionStorage();

        setTimeout(() => {
            if ($('#changeStoreModal').hasClass('show')) {
                $('#btn-continue-box').on('click', function() {
                    $.spinner().start();
                    setTimeout(() => {
                        var miniCartQuantity = verifyMiniCartQuantity();
                        if (isCalledFromCheckout && miniCartQuantity === 0) {
                            returnToUrl = $('.experience-theme-responsiveIcon a').attr('href');
                        }
                        if (returnToUrl) {
                            window.location.href = returnToUrl;
                        }
                    }, 2000);
                })
            } else {
                $.spinner().start();
                window.location.href = returnToUrl;
            }
        }, 2000);
    })
    // Usar MutationObserver para detectar cuando aparece .promo-bar dentro de .html-slot-container
    var path = window.location.pathname;
    if (!path.includes('Checkout') && !path.includes('Order-Confirm')) {
        var mainContent = document.getElementById('maincontent');
        if (mainContent) {
            var observer = new MutationObserver(function(mutations, obs) {
                var promoBar = document.querySelector('.html-slot-container .promo-bar');
                if (promoBar) {
                    mainContent.classList.add('maincontent-slot-active');
                    obs.disconnect();
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var header = document.querySelector('header.banner-color');
    var contentSlot = document.querySelector('.html-slot-container');
    if (!header || !contentSlot) return;

    var lastHeaderState = header.classList.contains('hide-nav');

    function updateContentSlotClass() {
        var isHidden = header.classList.contains('hide-nav');
        if (isHidden) {
            contentSlot.classList.add('header-hidden');
        } else {
            contentSlot.classList.remove('header-hidden');
        }
        lastHeaderState = isHidden;
    }

    // Observe class changes on the header
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'class') {
                updateContentSlotClass();
            }
        });
    });
    observer.observe(header, { attributes: true });

    // Initial state
    updateContentSlotClass();
});
